"use client";

import Map, {Marker} from "react-map-gl";
import 'mapbox-gl/dist/mapbox-gl.css';
import Image from "next/image";

interface LocationMapProps {
    coordinates: {
        lat: number;
        lng: number;
    };
    title: string;
}

export default function LocationMap({coordinates, title}: LocationMapProps) {
    const {lat, lng} = coordinates;

    return (
        <div className="h-full w-full">
            <Map
                mapboxAccessToken={process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN}
                initialViewState={{
                    longitude: lng,
                    latitude: lat,
                    zoom: 15
                }}
                mapStyle="mapbox://styles/carloiodice/cm25wbfxs00fy01pl906c51c3"
                style={{width: '100%', height: '100%'}}
                reuseMaps
                attributionControl={false}
                scrollZoom={false}
                dragPan={false}
                dragRotate={false}
                doubleClickZoom={false}
                touchZoomRotate={false}
                keyboard={false}
                minZoom={15}
                maxZoom={15}
            >
                <Marker longitude={lng} latitude={lat} anchor="bottom">
                    <div className="drop-shadow-lg" aria-label={`Posizione ${title}`}>
                        <Image
                            src="/assets/icon/pin-new.png"
                            alt={`Marker ${title}`}
                            width={64}
                            height={64}
                            priority
                            className="h-16 w-16 object-contain"
                        />
                    </div>
                </Marker>
            </Map>
        </div>
    );
}
